package app.properties

class FamilyType(val id: String, val name: String)
class EducationType(val id: String, val name: String)

class Person(
        var id: String? = null,
        var firstName: String = "",
        var lastName: String = "",
        var parentName: String = "",
        var address: String = "",
        var birthDay: String = "",
        var familyType: FamilyType? = null,
        var familyPersonCount: Int = 0,
        var education: EducationType? = null,
        var region: Region? = null,
        var area: String? = ""
) {
    fun isValid() : Boolean {

        return (firstName != "" &&
                lastName != "" &&
                parentName != "" &&
                address != "" &&
                birthDay != "" &&
                region != null &&
                area != "" &&
                education != null)
    }
}
